export const stringMapDefault = {
    ariaLabelCloseToast: "Close"
};
